/**
 * Whether the tab that leads to `to` is the current one at `pathname`.
 *
 * A tab stands for a whole part of the storefront, not for one address. The sale catalog is also
 * the home page (`/` shows it and is not redirected), and a rental's own page belongs to the rent
 * catalog while it keeps its old address (`/rentals/listing/:id` — the emails lead there). A link's
 * own prefix match cannot know either, so the rule is written down here.
 */
export const isCurrentTab = (to: string, pathname: string): boolean => {
  const under = (base: string) => pathname === base || pathname.startsWith(`${base}/`);

  if (to === '/buy') return pathname === '/' || under('/buy');
  if (to === '/rent') return under('/rent') || under('/rentals');

  return under(to);
};
